import Layout from "@/layout/index";
import Vue from "vue";
// import Layout2 from "@/layout/index2";
import UserInfoStore from "@/utils/UserInfoStore";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "登录",
    component: () => import("@/views/login/Login"),
    hidden: true,
  },
  {
    path: "/WeChatLogin",
    name: "微信登录",
    component: () => import("@/views/login/Login"),
    hidden: true,
  },
  {
    path: "/UserInfo",
    component: Layout,
    children: [
      {
        path: "",
        name: "个人信息",
        component: () => import("@/views/UserInfo/UserInfo"),
        meta: { title: "个人信息" },
        hidden: true,
      },
    ],
  },
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "首页",
        component: () => import("@/views/Home/Home"),
        meta: { title: "首页", icon: "icon-shouyefill" },
      },
    ],
  },
  {
    path: "/PowerStationManage",
    component: Layout,
    redirect: "/PowerStationManage",
    name: "站点管理",
    meta: { title: "站点管理", icon: "icon-chongdianzhuang" },
    children: [
      {
        path: "/PowerStationManage/CellManagement",
        name: "小区管理",
        component: () =>
          import("@/views/PowerStationManage/CellManagement/CellManagement"),
        meta: { title: "小区管理" },
      },
      {
        path: "/PowerStationManage/MyPowerStation",
        name: "设备管理",
        component: () =>
          import("@/views/PowerStationManage/MyPowerStation/MyPowerStation"),
        meta: { title: "设备管理" },
      },
      {
        path: "/PowerStationManage/AnnualFeeExpiresDevice",
        name: "年费到期设备",
        component: () =>
          import(
            "@/views/PowerStationManage/AnnualFeeExpiresDevice/AnnualFeeExpiresDevice"
          ),
        meta: { title: "年费到期设备" },
      },
      {
        path: "/PowerStationManage/DeviceExceptionInfo",
        name: "设备异常信息",
        component: () =>
          import("@/views/PowerStationManage/DeviceExceptionInfo"),
        meta: {
          title: "设备异常信息",
        },
      },
      {
        path: "/PowerStationManage/DeviceStatistics",
        name: "设备统计",
        component: () =>
          import("@/views/PowerStationManage/MyPowerStation/MyPowerStationTwo"),
        meta: { title: "设备统计" },
      },
      {
        path: "/PowerStationManage/OffLineLog",
        name: "离线统计",
        component: () =>
          import("@/views/PowerStationManage/OffLineLog/OffLineLog"),
        meta: { title: "离线统计" },
      },
      // {
      //   path: "/PowerStationManage/BillingTemplate",
      //   name: "计费模板",
      //   component: () =>
      //     import("@/views/PowerStationManage/BillingTemplate/BillingTemplate"),
      //   meta: { title: "计费模板" },
      // },
      {
        path: "/PowerStationManage/PowerStationDetail/:id",
        name: "设备详细",
        component: () =>
          import("@/views/PowerStationManage/PowerStationDetail"),
        hidden: true,
        meta: { title: "设备详细" },
      },
      {
        path: "/PowerStationManage/ProxyPowerStation",
        name: "子代理设备",
        component: () => import("@/views/PowerStationManage/ProxyPowerStation"),
        meta: { title: "子代理设备" },
      },
      // {
      //   path: "/PowerStationManage/NoBindPowerStation",
      //   name: "未绑定设备",
      //   component: () =>
      //     import("@/views/PowerStationManage/NoBindPowerStation"),
      //   meta: { title: "未绑定设备" },
      // },
    ],
  },
  {
    path: "/User",
    component: Layout,
    redirect: "/User",
    children: [
      {
        path: "/User",
        name: "用户管理",
        component: () => import("@/views/UserManage/UserManage"),
        meta: { title: "用户管理", icon: "icon-yonghu21", roles: ["admin"] },
      },
      {
        path: "/User/userManage/:id",
        name: "用户详细",
        component: () =>
          import("@/views/UserManage/UserManageDetail/UserManageDetail"),
        hidden: true,
        meta: { title: "用户详细" },
      },
    ],
  },
  {
    path: "/ElectricityCardManage",
    component: Layout,
    redirect: "/ElectricityCardManage",
    children: [
      {
        path: "/ElectricityCardManage",
        name: "电卡管理",
        component: () =>
          import("@/views/ElectricityCardManage/ElectricityCardManage"),
        meta: { title: "电卡管理", icon: "icon-card" },
      },
      {
        path: "/ElectricityCardManage/:cardId",
        name: "电卡详细",
        component: () =>
          import(
            "@/views/ElectricityCardManage/ElectricityCardDetail/ElectricityCardDetail"
          ),
        hidden: true,
        meta: { title: "电卡详细" },
      },
    ],
  },
  {
    path: "/RFCardManage",
    component: Layout,
    redirect: "/RFCardManage",
    children: [
      {
        path: "/RFCardManage",
        name: "射频卡管理",
        component: () => import("@/views/RFCardManage/RFCardManage"),
        meta: { title: "射频卡管理", icon: "icon-card" },
      },
    ],
  },
  {
    path: "/StatisticsCentre",
    component: Layout,
    redirect: "/StatisticsCentre",
    name: "统计中心",
    meta: { title: "统计中心", icon: "icon-shuzhuangtu" },
    children: [
      {
        path: "/StatisticsCentre/orderRecord",
        name: "订单记录",
        component: () => import("@/views/StatisticsCentre/orderRecord"),
        meta: { title: "订单记录" },
        // children: [
        //   {
        //     path: "/StatisticsCentre/RechargeOrder",
        //     name: "充电订单",
        //     component: () => import("@/views/StatisticsCentre/RechargeOrder"),
        //     meta: { title: "充电订单" },
        //   },
        //   {
        //     path: "parkingLog",
        //     name: "停车订单",
        //     component: () => import("@/views/ParkingOrder/Index"),
        //     meta: { title: "停车订单" },
        //   },
        // ],
      },
      {
        path: "/StatisticsCentre/RechargeMonthlyRecord",
        name: "包月记录",
        component: () =>
          import("@/views/StatisticsCentre/RechargeMonthlyRecord"),
        meta: { title: "包月记录" },
      },
      {
        path: "/StatisticsCentre/RechargeRecord",
        name: "充值记录",
        component: () => import("@/views/StatisticsCentre/RechargeRecord"),
        meta: { title: "充值记录" },
      },
      {
        path: "/StatisticsCentre/RevenueChart",
        name: "营收报表",
        component: () => import("@/views/StatisticsCentre/RevenueChart"),
        meta: { title: "营收报表" },
      },
      {
        path: "/StatisticsCentre/RecordDetail",
        name: "提现管理",
        component: () => import("@/views/StatisticsCentre/RecordDetail"),
        meta: { title: "提现管理" },
        hidden: () => {
          //绑定了商户平台没有提现功能
          return UserInfoStore.getInfo().useChargeToBalance === 1;
        },
      },
      {
        path: "deviceAnnualFeePayLog",
        name: "年费付款记录",
        component: () => import("@/views/DeviceAnnualFeePayLog/index"),
        meta: { title: "年费付款记录" },
      },
    ],
  },
  {
    path: "/OperatorsManage",
    component: Layout,
    redirect: "/OperatorsManage/AgencyList",
    name: "运营商管理",
    meta: { title: "运营商管理", icon: "icon-fuwujieshao" },
    children: [
      {
        path: "/OperatorsManage/AgencyList",
        name: "子代理列表",
        component: () => import("@/views/OperatorsManage/AgencyList"),
        meta: { title: "子代理列表", roles: ["admin"] },
      },
      {
        path: "/OperatorsManage/DividendManage",
        name: "分润方管理",
        component: () => import("@/views/OperatorsManage/DividendManage"),
        meta: { title: "分润方管理" },
      },
      {
        path: "/OperatorsManage/maintenanceManage",
        name: "维修管理",
        component: () => import("@/views/OperatorsManage/maintenanceList"),
        meta: { title: "维修管理" },
      },
    ],
  },
  {
    path: "/UserCar",
    component: Layout,
    redirect: "/UserCar",
    children: [
      {
        path: "/UserCar",
        name: "车辆管理",
        component: () => import("@/views/UserCar/UserCar"),
        meta: { title: "车辆管理", icon: "icon-peisong1" },
      },
      // {
      //   path: "/ElectricityCardManage/:cardId",
      //   name: "电卡详细",
      //   component: () =>
      //     import(
      //       "@/views/ElectricityCardManage/ElectricityCardDetail/ElectricityCardDetail"
      //     ),
      //   hidden: true,
      //   meta: { title: "电卡详细" },
      // },
    ],
  },
  {
    path: "/GarageManage",
    component: Layout,
    redirect: "/GarageManage/GarageManage",
    name: "车库管理",
    meta: { title: "车库管理", icon: "icon-cangkushangpinguanli" },
    children: [
      {
        path: "/GarageManage/GarageManage",
        name: "车库管理",
        component: () => import("@/views/GarageManage/GarageManage"),
        meta: { title: "车库管理" },
      },
      // {
      //   path: "/GarageManage/CarTypeOfCarport",
      //   name: "车辆类型",
      //   component: () => import("@/views/GarageManage/CarTypeOfCarport"),
      //   meta: { title: "车辆类型" },
      // },
      {
        path: "/GarageManage/AccessControlDevice",
        name: "门禁管理",
        component: () => import("@/views/GarageManage/AccessControlDevice"),
        meta: { title: "门禁管理" },
      },
      // {
      //   path: "/GarageManage/CarportChargeTemplate",
      //   name: "收费模板",
      //   component: () => import("@/views/GarageManage/CarportChargeTemplate"),
      //   meta: { title: "收费模板" },
      // },
      // {
      //   path: "/GarageUserManage",
      //   name: "用户管理",
      //   component: () => import("@/views/GarageManage/GarageUserManage"),
      //   meta: { title: "用户管理" },
      // },
      // {
      //   path: "/carport/statisticsCentre",
      //   name: "统计中心",
      //   component: Layout2,
      //   meta: { title: "统计中心" },
      //   children: [
      //     {
      //       path: "parkingLog",
      //       name: "停车记录",
      //       component: () => import("@/views/ParkingOrder/Index"),
      //       meta: { title: "停车记录" },
      //     },
      //     {
      //       path: "monthlyLog",
      //       name: "包月记录",
      //       component: () => import("@/views/ParkingMonthly/Index"),
      //       meta: { title: "包月记录" },
      //     },
      //      {
      //         path: 'incomeStatistics',
      //         name: '营收统计',
      //         component: () => import('@/views/UserCar/RevenueChart.vue'),
      //         meta: {title: '营收统计'}
      //     },
      //   ],
      // },
    ],
  },
  // {
  //     path: '/Monthly',
  //     component: Layout,
  //     redirect: '/Monthly/Monthly',
  //     name: '包月管理',
  //     meta: {title: '包月管理', icon: 'el-icon-s-goods'},
  //     children: [
  //         {
  //             path: '/monthly/monthlyMember',
  //             name: '包月用户',
  // component: Layout2,
  //             meta: {title: '包月用户'},
  //             children: [
  //                 {
  //                     path: 'charge',
  //                     name: '充电包月用户',
  //                     component: () => import('@/views/Monthly/MonthlyMember/ChargeMonthlyMember'),
  //                     meta: {title: '充电包月用户'}
  //                 }
  //                 // , {
  //                 //     path: 'carport',
  //                 //     name: '车库包月用户',
  //                 //     component: () => import('@/views/Monthly/MonthlyMember/CarportMonthlyMember'),
  //                 //     meta: {title: '车库包月用户'}
  //                 // },
  //             ]
  //         },
  // {
  //     path: '/carport/statisticsCentre',
  //     name: '包月记录',
  // component: Layout2,
  //     meta: {title: '包月记录'},
  //     children: [
  //         {
  //             path: 'charge',
  //             name: '充电包月记录',
  //             component: () => import('@/views/Monthly/MonthlyLog/ChargeMonthlyRecord'),
  //             meta: {title: '充电包月记录'}
  //         }
  //         , {
  //             path: 'carport',
  //             name: '车库包月记录',
  //             component: () => import('@/views/Monthly/MonthlyLog/CarportMonthlyRecord'),
  //             meta: {title: '车库包月记录'}
  //         },
  //     ]
  // }
  //     ]
  // },
  {
    path: "/globalConfig",
    component: Layout,
    redirect: "/globalConfig",
    children: [
      {
        path: "globalConfig",
        name: "全局配置",
        component: () => import("@/views/globalConfig/globalConfig"),
        meta: { title: "全局配置", icon: "el-icon-setting" },
      },
    ],
  },
  {
    path: "/FeedBack",
    component: Layout,
    redirect: "/FeedBack",
    children: [
      {
        path: "FeedBack",
        name: "用户反馈",
        component: () => import("@/views/FeedBack/FeedBack"),
        meta: { title: "用户反馈", icon: "icon-yijianfankui" },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  let u = navigator.userAgent;
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isiOS && to.path !== location.pathname) {
    location.assign(to.fullPath);
  } else {
    next();
  }
});
export default router;
